// Imports
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import VueMatomo from 'vue-matomo'
import moment from 'moment'
import IdleVue from 'idle-vue'

// Plugins
import '@/plugins/bootstrap-vue'
import '@/plugins/fontawesome-vue'
import '@/plugins/moment-vue'
import '@/plugins/composition-api-vue'
import '@/plugins/vue-scrollable-tabs'
import '@/plugins/vue-clipboard2'

import { belugaDataModel } from '@/mixins/beluga_datamodel'

// Global stylesheet
import './App.css'

// Constants
const INACTIVITY_TIMOUT_MS = 900000 // 15 min

// Other settings
Vue.config.productionTip = true

// Initialize Vue Router
Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    // dynamic segments start with a colon
    { name: 'base-dev', path: '/beluga-web/:campaign?' },
    { name: 'base', path: '/:campaign?' },
    { path: '/css/*' },
    { path: '/js/*' },
    { path: '/tools/*' },
    { path: '/nextcloud' },
    { path: '/data' },
    { path: '/matomo' },
    { path: '/phpmyadmin' }
  ],
  mode: 'history'
})

// Use Matomo
Vue.use(VueMatomo, {
  host: 'https://beluga.geomar.de/matomo',
  siteId: 1,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: true,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
})

const vm = new Vue({
  router: router,
  window,
  render: h => h(App),
  store: belugaDataModel,
  data: {
    window: {
      width: 0,
      height: 0
    }
  },
  created () {
    // Configure moment
    moment.relativeTimeThreshold('ss', -1)
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d sec',
        m: 'a min',
        mm: '%d min',
        h: 'an hr',
        hh: '%d hrs',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
      }
    })
    // Add window resize listener
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      this.$root.$emit('windowResize', { width: this.window.width, height: this.window.height })
    }
  }
}).$mount('#app')

// Initialize Idle Vue
Vue.use(IdleVue, {
  eventEmitter: vm,
  store: belugaDataModel,
  idleTime: INACTIVITY_TIMOUT_MS, // 30 minutes
  startAtIdle: false
})

export { vm }
